@if (messages | dsl | async; as contentMessages) {
    <vn-content-messages class="am-content-messages" [messages]="contentMessages" closedCookieKey="vn-t" />
}
